
/**
 * 강의 콘텐츠 유형
 */
export type GetLectureDetail200ContentType = typeof GetLectureDetail200ContentType[keyof typeof GetLectureDetail200ContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetLectureDetail200ContentType = {
  VIDEO: 'VIDEO',
  MARKDOWN: 'MARKDOWN',
  VIDEO_MARKDOWN: 'VIDEO_MARKDOWN',
  QUIZ: 'QUIZ',
  EXTERNAL_LINK: 'EXTERNAL_LINK',
  TEXT: 'TEXT',
} as const;
